(function () {
	'use strict';
	$(document).ready(function () {

		new Swiper('.swiper-products', {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 40,
			navigation: {
				prevEl: '.swiper-button-prev',
				nextEl: '.swiper-button-next',
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
				},
				576: {
					slidesPerView: 2,
				},
			},
			scrollbar: {
				el: '.swiper-scrollbar',
				hide: false,
			},
		});

	});
}(jQuery));
